module.exports = __webpack_public_path__ + "static/q7answer1_pool_wishmas-65ae3c698ce61b89bad9a8b4531c32c7.jpg";